const category = [
  { id: 0, name: "All", isActive: 1 },
  { id: 1, name: "Commercials", isActive: 0 },
  { id: 4, name: "Music Videos", isActive: 0 },
  { id: 3, name: "Narrative", isActive: 0 },
  // { id: 2, name: "Long Format", isActive: 0 },
];

export default category;
